// @ts-strict-ignore
import { useState } from 'react'

import { ContactData, ContactForm } from '@/features/product/CreatePrereservation/ui/NpiRequestModal/ui/ContactForm'

import { fetchReservation } from '@/entities/product'

import { bitrixChat } from '@/shared/integrations/BitrixChat'
import { BASE_URL } from '@/shared/lib/const/env'
import { TProduct } from '@/shared/types/product-types'
import { Button, Col, Row } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'
import { FormSuccessMessage } from '@/shared/ui/FormSuccessMessage'
import { Image } from '@/shared/ui/Image'

import styles from './NpiRequestModal.module.scss'

const SUCCESS_TITLE = `Ваша заявка принята`
const SUCCESS_SUBTITLE = `Мы с вами свяжемся и сообщим, когда появится возможность заказать товар`

export type TNpiFormFields = {
	KOD: string | undefined
} & ContactData

/**
 * Subscription form for notification of receipt of goods (NPI)
 * @param props - product data
 */
export const NpiRequestModal = ({
	TITLE,
	IMAGE,
	KOD,
	onOk,
	IMAGES = []
}: Partial<TProduct> & { onOk: () => void; onCancel?: () => void }): JSX.Element => {
	const [errorMessage, setErrorMessage] = useState<string>(``)
	const [isRequestSucceeded, setIsRequestSucceeded] = useState<boolean>(false)
	const [loading, setLoading] = useState(false)

	const handleChatOpen = () => {
		try {
			// Открываем AI-чат через клик на кнопку
			const aiChatButton = document.getElementById('ai-open-chat')
			if (aiChatButton) {
				aiChatButton.click()
			} else {
				// Если AI-чат недоступен, пробуем открыть Bitrix чат
				bitrixChat.open()
			}
		} catch (error) {
			// Если чаты недоступны, открываем страницу контактов
			window.open('/contacts', '_blank')
		}
	}

	const onSubmit = async (values: ContactData) => {
		setLoading(true)
		const payload: TNpiFormFields = {
			KOD,
			...values
		}

		try {
			await fetchReservation(payload)

			setIsRequestSucceeded(true)
		} catch (e) {
			setErrorMessage(e.toString())
		}

		setLoading(false)
	}

	return (
		<section className={styles.modal} onClick={e => e.stopPropagation()}>
			{isRequestSucceeded ? (
				<Flex center>
					<FormSuccessMessage title={SUCCESS_TITLE} subtitle={SUCCESS_SUBTITLE} onOk={onOk} />
				</Flex>
			) : (
				<>
					<h2>Сообщить о старте предзаказа</h2>

					{/* {!!errorMessage && errorMessage} */}

					{!!errorMessage && (
						<div className={styles.errorBlock}>
							<p className={styles.errorMessage}>Произошла ошибка. Обратитесь в чат поддержки.</p>
							<Button onClick={handleChatOpen} theme="link" className={styles.chatLink}>
								Открыть чат с AI-ассистентом
							</Button>
						</div>
					)}

					<Row gutter={[20, 20]}>
						<Col xs={24} sm={10}>
							<Flex column alignCenter>
								<Image alt={TITLE} width={180} height={180} src={IMAGE ? BASE_URL + IMAGE : BASE_URL + IMAGES[0]} />

								<h5 style={{ margin: 0 }}>{TITLE}</h5>
							</Flex>
						</Col>
						<Col xs={24} sm={14}>
							<ContactForm
								onSubmit={onSubmit}
								direction="vertical"
								withApplyMessage
								loading={loading}
								userAutocomplete
							/>
						</Col>
					</Row>
				</>
			)}
		</section>
	)
}
